<template>
    
</template>

<script>
    export default {
        name: "Cardiologies"
    }
</script>

<style scoped>

</style>